/*
 * @Description: 添加文件描述
 * @Author: licheng09
 * @LastEditors: yangfei03
 * @Date: 2019-01-08 11:46:22
 * @LastEditTime: 2019-10-17 21:28:43
 */
import store from './Store';
import request from 'api/Request';
import { getRequestParams } from 'tools/utils';
import ActionLog from 'api/ActionLog';

// 登录url
const loginUrl = `${window.location.protocol}//m.m.58.com/open/login`;
// 绑定手机号
const mobileBindUrl = `${window.location.protocol}//m.m.58.com/open/mobilebind`;

// 业务线标识
const source = 'cash_loan';

// 默认登录方式
// const defaulttype = 2;

// 限制登录方式
const onlymobile = 1;

// 第三方登录方式
const ishidethird = 1;

/**
 * 特简单的cookie获取
 */
function getCookie(name) {
    const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
    const arr = document.cookie.match(reg);
    if (!arr) {
        return null;
    } else {
        return arr[2];
    }
}
/**
 * 获取当前页面地址
 */
function getCurPath() {
    return `${window.location.origin}${window.location.pathname}${window.location.search}`;
}
/**
 * 判断是否是在58app内
 */
export function is58App() {
    const _ua = navigator.userAgent;
    // 在ios 7.3.1中 还看到有WBUA的标识，所以都判断一下吧~
    return _ua.indexOf('WUBA') !== -1 || _ua.indexOf('WBUA') !== -1;
}
/**
 * 获取当前app是android还是ios
 */
export function getOs() {
    return getCookie('os');
}

/**
 * 获取passport登录的url
 * @param {String} path 回跳的url
 */
export function mLoginPath() {
    const path = getCurPath();
    return `${loginUrl}?path=${encodeURIComponent(path)}&source=${source}&onlymobile=${onlymobile}&ishidethird=${ishidethird}`;
}

/**
 * 获取passport绑定手机号的url
 * @param {String} path 回跳的url
 */
export function mobileBindPath() {
    const path = getCurPath();
    return `${mobileBindUrl}?path=${encodeURIComponent(path)}`;
}

/**
 * @param {*} data
 */
export function cacheProcessData(data) {
    // 申请状态
    store.set('CURAPPLYSTATUS', data.applyStatus - 0);
    // 申请阶段  当前进度
    store.set('CURAPPLYPROGRESS', data.applyProgress - 0);
    // 用户当前状态
    store.set('CURUSERSTATUS', data.userStatus - 0);
    // 如果是风控冻结时候会有冻结时长
    if (data.userStatus - 0 === 3) {
        store.set('FORZENLENGTH', data.forzenLength);
    }
    // 是否为新支付用户（2为新，1为老）
    store.set('CUSTFLAG', data.newCustFlag || 1);
    // p2p用户标识
    store.set('ISP2PUSER', data.p2pUser);
}

// 返回增验的path
const RISK_ITEMS = {
    B101: '/auth/faceplus',
    B102: '/auth/idcard',
    B103: '/auth/baseinfo',
    B104: '/auth/smscode',
    B105: '/auth/juxinli',
};
export function getNextSupplyItem(key) {
    return RISK_ITEMS[key];
}

export function getTransferData(callback) {
    request.get('/apply/status').then((res = {}) => {
        if (res.code === 0) {
            cacheProcessData(res.data);
        }
        callback && callback(res);
    }).catch((e) => {
        try {
            e.message += ':Helper:113';
            window.JSTracker.catch(e);
            ActionLog.setWmdaReport({ event_id: '140', event_name: 'haojie_getstatus_error_report' });
        } catch (err) {
            throw e;
        }
    });
}

/**
 * 格式化风控冻结时间
 * @author lihaonan04
 * @param {String、Number} freezeHour 风控冻结的小时数
 */
export function getFormatHour(freezeHour) {
    let formatHour = '';
    if (freezeHour > 72) {
        const d = parseInt(freezeHour / 24, 10);
        const h = freezeHour % 24;
        formatHour = h === 0 ? `${d}天` : `${d}天${h}小时`;
    } else {
        formatHour = `${freezeHour}小时`;
    }
    return formatHour;
}

/**
 * 忘记密码跳转
 * @author lihaonan04
 */
export function forgetPwd() {
    let UID = '';
    // 开发环境没有cookie无法取到PPU的值，防止报错，给一个固定的UID
    if (process.env.NODE_ENV === 'development') {
        UID = 56927204961294;
    } else {
        // 获取PPU
        const PPU = getCookie('PPU');
        // 取值，写的繁琐，后面改成正则
        const PPUList = PPU.split('&');
        for (let i = 0, len = PPUList.length; i < len; i++) {
            const item = PPUList[i];
            if (/UID/.test(item)) {
                UID = item.split('=')[1];
                break;
            }
        }
    }

    // 判断当前用户是否为新支付用户，新、老支付用户的bizid不同
    const newCustFlag = store.get('CUSTFLAG');
    let bizid = '';
    if (Number(newCustFlag) === 1) {
        bizid = 4;
    } else {
        bizid = 100102006;
    }
    const { href } = window.location;
    window.location.href = `https://jruc.58.com/ucweb/resetPwd.html?actid=${UID}&bizid=${bizid}&returnUrl=${encodeURIComponent(href)}`;
}
/**
 * 判断是否是在赶集app内
 */
export function isGanjiApp() {
    return window.navigator.userAgent.indexOf('ganji') !== -1;
}

/**
 * 判断是否是在安居客app内
 */
export function isAnjukeApp() {
    return window.location.href.indexOf('from=anjukeApp') !== -1;
}
/**
 * 判断是否是在好借app内
 */
export function isHaojieApp() {
    return navigator.userAgent.indexOf('JRHaoJie') !== -1;
}

/**
 * 判断是否是在好借app内
 */
export function isXinyongjinApp() {
    return navigator.userAgent.indexOf('JRXinYongJin') !== -1;
}

/**
 * 判断是否是在微信app内
 */
export function isWeChat() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
}
/**
 * 判断是否是在sdk app内
 */
export function isSDKApp() {
    return navigator.userAgent.indexOf('JRXJSDK') !== -1;
}
/**
 * 判断是否是在app内
 */
export function isApp() {
    return is58App() || isGanjiApp() || isAnjukeApp() || isHaojieApp() || isXinyongjinApp() || isSDKApp();
}

/**
 * 判断是否登录
 */
export function isNoLogin() {
    if (isHaojieApp()) {
        return !getCookie('PPU');
    } else {
        return getCookie('PPU') === '""' || getCookie('PPU') === null;
    }
}
/**
 * 好借App判断是否绑定手机号
 */
export function isBind() {
    return !!getCookie('isbind');
}

// 处理iPhoneX 下面的吸底按钮 Header标识 hasBottomBtn={true}
export function getiPhoneXBottomHeight() {
    const dom = document.getElementById('iphonex-info');
    let iPhoneXBottomHeight = 0;
    if (dom && iPhoneXBottomHeight === 0 && isApp()) {
        iPhoneXBottomHeight = +getStyle(dom, 'height').replace('px', '');
    }
    return iPhoneXBottomHeight;
}

function getStyle(element, attr) {
    if (element.currentStyle) {
        return element.currentStyle[attr];
    } else {
        return getComputedStyle(element, false)[attr];
    }
}

export function createKey() {
    return Math.random().toString(36).substr(2, 6);
}
// URL加上from参数生成逻辑
export function urlAddFrom(jumpUrl) {
    if (!/[?&#]from=([^&#]*)/g.test(jumpUrl)) {
        const before = jumpUrl.indexOf('?') > 0 ? '&' : '?';
        return jumpUrl + (getRequestParams().from ? `${before}from=${getRequestParams().from}` : '');
    }
    return jumpUrl;
}



// WEBPACK FOOTER //
// ./src/api/Helper.js